import React from "react";
import _ from "lodash";

import CUSTOMER_STATUSES from "./constants/CUSTOMER_STATUSES";

import Home from "./containers/Home/Home.container.lazy";
import Login from "./containers/Login/Login.container.lazy";
import Register from "./containers/Register/Register.container.lazy";
import Otp from "./containers/Otp/Otp.container.lazy";
import AddressDetails from "./containers/AddressDetails/AddressDetails.container.lazy";
import ConsentAuthorization from "./containers/ConsentAuthorization/ConsentAuthorization.container.lazy";
import TinkFinished from "./containers/TinkFinished/TinkFinished.container.lazy";
import Dashboard from "./containers/Dashboard/Dashboard.container.lazy";
import LoanRequest from "./containers/LoanRequest/LoanRequest.container.lazy";
import Documents from "./containers/Documents/Documents.container.lazy";
import FinancialInfo from "./containers/FinancialInfo/FinancialInfo.container.lazy";
import LoanApply from "./containers/LoanApply/LoanApply.container.lazy";
import Rollover from "./containers/Rollover/Rollover.container.lazy";
import Restructure from "./containers/Restructure/Restructure.container.lazy";
import Payment from "./containers/Payment/Payment.container.lazy";
import PaymentReason from "./containers/PaymentReason/PaymentReason.container.lazy";
import Account from "./containers/Account/Account.container.lazy";
import Handover from "./containers/Handover/Handover.container.lazy";
import CreditHistory from "./containers/CreditHistory/CreditHistory.container.lazy";
import StaticPages from "./containers/StaticPages/StaticPages.container.lazy";
import Shortlink from "./containers/Shortlink/Shortlink.container.lazy";

import Unsubscribe from "./components/Unsubscribe/Unsubscribe.component.lazy";
import ErrorPage from "./components/ErrorPage/ErrorPage.component";
import LoginRedirect from "./components/LoginRedirect/LoginRedirect.component";
import PrivacyPolicyRedirect from "./components/PrivacyPolicyRedirect/PrivacyPolicyRedirect.component";
import DeclinedView from "./components/DeclinedView/DeclinedView.component.lazy";

interface RouteItem {
  key: string;
  url: string;
  title?: string;
  authTypes: string[];
  authTypesForbidden: string[];
  hideFooterOnMobile?: boolean;
  hideHeader?: boolean;
  hideFooter?: boolean;
  component:
    | React.LazyExoticComponent<() => React.JSX.Element | null>
    | ((props: any) => React.JSX.Element | null);
  slug?: string;
}

const routesObject = {

  home: {
    key: "home",
    url: "/",
    title: "¡Préstamos Rápidos en myKredit! Solicita en menos de 10 minutos.",
    component: Home,
    authTypes: [],
    authTypesForbidden: []
  },

  login: {
    key: "login",
    url: "/login",
    component: Login,
    authTypes: [],
    authTypesForbidden: _.values(CUSTOMER_STATUSES),
    hideFooterOnMobile: true
  },

  loginOtp: {
    key: "loginOtp",
    url: "/login/otp",
    component: Login,
    authTypes: [],
    authTypesForbidden: _.values(CUSTOMER_STATUSES),
    hideFooterOnMobile: true
  },

  loginRedirect: {
    key: "loginRedirect",
    url: "/iniciar-sesion",
    component: LoginRedirect,
    authTypes: [],
    authTypesForbidden: []
  },

  loginForgotPin: {
    key: "loginForgotPin",
    url: "/login/forgot-pin",
    component: Login,
    authTypes: [],
    authTypesForbidden: _.values(CUSTOMER_STATUSES),
    hideFooterOnMobile: true
  },

  loginResetPassword: {
    key: "loginResetPassword",
    url: "/login/reset-password",
    component: Login,
    authTypes: [],
    authTypesForbidden: _.values(CUSTOMER_STATUSES),
    hideFooterOnMobile: true
  },

  register: {
    key: "register",
    url: "/registro/datos-personales",
    component: Register,
    authTypes: [],
    authTypesForbidden: _.values(CUSTOMER_STATUSES),
    hideFooterOnMobile: true
  },

  otp: {
    key: "otp",
    url: "/otp",
    component: Otp,
    authTypes: [
      CUSTOMER_STATUSES.new
    ],
    authTypesForbidden: Object.values(
      _.omit(CUSTOMER_STATUSES, CUSTOMER_STATUSES.new)
    ),
    hideFooterOnMobile: true
  },

  otpChangeMobile: {
    key: "otpChangeMobile",
    url: "/otp/change-mobile",
    component: Otp,
    authTypes: [
      CUSTOMER_STATUSES.new
    ],
    authTypesForbidden: Object.values(
      _.omit(CUSTOMER_STATUSES, CUSTOMER_STATUSES.new)
    ),
    hideFooterOnMobile: true
  },

  addressDetails: {
    key: "addressDetails",
    url: "/address-details",
    component: AddressDetails,
    authTypes: [
      CUSTOMER_STATUSES.preRegistered,
      CUSTOMER_STATUSES.registered,
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  addressDetailsDeclined: {
    key: "addressDetailsDeclined",
    url: "/address-details/declined",
    component: DeclinedView,
    authTypes: [],
    authTypesForbidden: []
  },

  dashboard: {
    key: "dashboard",
    url: "/dashboard",
    component: Dashboard,
    authTypes: [
      CUSTOMER_STATUSES.registered,
      CUSTOMER_STATUSES.declined,
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  dashboardDeclined: {
    key: "dashboardDeclined",
    url: "/dashboard/declined",
    component: Dashboard,
    authTypes: [
      CUSTOMER_STATUSES.declined,
      CUSTOMER_STATUSES.registered,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: []
  },

  consentAuthorization: {
    key: "consentAuthorization",
    url: "/consent-authorization",
    component: ConsentAuthorization,
    authTypes: [
      CUSTOMER_STATUSES.registered
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  tinkFinished: {
    key: "tinkFinished",
    url: "/tink-finished",
    component: TinkFinished,
    authTypes: [
      CUSTOMER_STATUSES.registered
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  loanRequest: {
    key: "loanRequest",
    url: "/loan-request",
    component: LoanRequest,
    authTypes: [
      CUSTOMER_STATUSES.registered,
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.declined,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  loanRequestChangeAccount: {
    key: "loanRequestChangeAccount",
    url: "/loan-request/change-account",
    component: LoanRequest,
    authTypes: [
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.securityChecked
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  loanRequestSuccess: {
    key: "loanRequestSuccess",
    url: "/loan-request/success",
    component: LoanRequest,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  loanRequestDeclined: {
    key: "loanRequestDeclined",
    url: "/loan-request/declined",
    component: LoanRequest,
    authTypes: [
      CUSTOMER_STATUSES.preRegistered,
      CUSTOMER_STATUSES.registered,
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.declined,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: []
  },

  documents: {
    key: "documents",
    url: "/documents",
    component: Documents,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  financialInfoAddCard: {
    key: "financialInfoAddCard",
    url: "/financial-info/add-card",
    component: FinancialInfo,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  financialInfoActiveCards: {
    key: "financialInfoActiveCards",
    url: "/financial-info/active-cards",
    component: FinancialInfo,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  financialInfoUploadCard: {
    key: "financialInfoUploadCard",
    url: "/financial-info/upload-card/:referer?",
    component: FinancialInfo,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  loanApply: {
    key: "loanApply",
    url: "/loan-apply",
    component: LoanApply,
    authTypes: [
      CUSTOMER_STATUSES.registered,
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  rollover: {
    key: "rollover",
    url: "/rollover/:loanId",
    component: Rollover,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  rolloverSuccess: {
    key: "rolloverSuccess",
    url: "/rollover-success",
    component: Rollover,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  restructure: {
    key: "restructure",
    url: "/restructure/:loanId",
    component: Restructure,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  restructureSuccess: {
    key: "restructureSuccess",
    url: "/restructure-success",
    component: Restructure,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  payment: {
    key: "payment",
    url: "/payment/pay/:paymentType/:loanId/:installmentId?",
    component: Payment,
    authTypes: [
      CUSTOMER_STATUSES.registered,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  paymentSuccess: {
    key: "paymentSuccess",
    url: "/payment/success/:paidType?",
    component: Payment,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.declined,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  paymentResult: {
    key: "paymentResult",
    url: "/payment/result",
    component: Payment,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [
      CUSTOMER_STATUSES.new,
      CUSTOMER_STATUSES.preRegistered,
      CUSTOMER_STATUSES.registered,
      CUSTOMER_STATUSES.systemApproved
    ],
    hideFooterOnMobile: true
  },

  paymentReason: {
    key: "paymentReason",
    url: "/payment-reason",
    component: PaymentReason,
    authTypes: [
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  account: {
    key: "account",
    url: "/account",
    component: Account,
    authTypes: [
      CUSTOMER_STATUSES.declined,
      CUSTOMER_STATUSES.registered,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  handover: {
    key: "handover",
    url: "/handover/v1/:introductionId",
    component: Handover,
    authTypes: [],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  creditHistory: {
    key: "creditHistory",
    url: "/credit-history",
    component: CreditHistory,
    authTypes: [
      CUSTOMER_STATUSES.declined,
      CUSTOMER_STATUSES.registered,
      CUSTOMER_STATUSES.systemApproved,
      CUSTOMER_STATUSES.securityChecked,
      CUSTOMER_STATUSES.internalCollection,
      CUSTOMER_STATUSES.externalCollection,
      CUSTOMER_STATUSES.demand,
      CUSTOMER_STATUSES.reclamation,
      CUSTOMER_STATUSES.legalCollection,
      CUSTOMER_STATUSES.fraud,
      CUSTOMER_STATUSES.processCollection
    ],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  aboutUs: {
    key: "aboutUs",
    url: "/sobre-nosotros",
    title: "Todos los datos sobre myKredit, expertos en préstamos rápidos",
    component: StaticPages,
    authTypes: [],
    authTypesForbidden: []
  },

  cookiePolicy: {
    key: "cookiePolicy",
    url: "/cookie",
    title: "Política de Cookies",
    component: StaticPages,
    authTypes: [],
    authTypesForbidden: []
  },

  privacyPolicy: {
    key: "privacyPolicy",
    url: "/politica-privacidad",
    title: "Política de Privacidad",
    component: StaticPages,
    authTypes: [],
    authTypesForbidden: []
  },

  emcPolicy: {
    key: "emcPolicy",
    url: "/clausula-medios-electronicos",
    title: "Cláusula de Medios Electrónicos",
    component: StaticPages,
    authTypes: [],
    authTypesForbidden: []
  },

  privacyPolicyRedirect: {
    key: "privacyPolicyRedirect",
    url: "/policita-privacidad",
    component: PrivacyPolicyRedirect,
    authTypes: [],
    authTypesForbidden: []
  },

  terms: {
    key: "terms",
    url: "/terminos-condiciones",
    title: "Términos y Condiciones",
    component: StaticPages,
    authTypes: [],
    authTypesForbidden: []
  },

  contactUs: {
    key: "contactUs",
    url: "/contactanos",
    title: "Contáctanos",
    component: StaticPages,
    authTypes: [],
    authTypesForbidden: []
  },

  shortLinks: {
    key: "shortLinks",
    url: "/r(x|s?)/:repayToken",
    component: Shortlink,
    authTypes: [],
    authTypesForbidden: [],
    hideFooterOnMobile: true
  },

  unsubscribe: {
    key: "unsubscribe",
    url: "/unsubscribe",
    component: Unsubscribe,
    authTypes: [],
    authTypesForbidden: []
  },

  error: {
    key: "error",
    url: "*",
    title: "404",
    component: ErrorPage,
    authTypes: [],
    authTypesForbidden: []
  }
} satisfies Record<string, RouteItem>;

type RouteKeys = keyof typeof routesObject;
type RouteConfig = typeof routesObject;

export default routesObject;
export type { RouteItem, RouteConfig, RouteKeys };
